module.exports = __webpack_public_path__ + "static/img/8.0ebe09f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/8.png
// module id = lXyu
// module chunks = 0